import { createAsyncThunk } from "@reduxjs/toolkit";
import courseService from "src/services/Course/course.service";

export const getCourseByAdmissionId = createAsyncThunk(
  "course/getCourseByAdmissionId",
  async (admission_id: number) => {
    return courseService.getCourseByAdmissionId(admission_id);
  }
);
